import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { storeToRefs } from 'pinia';
import { useDevice } from '@/hooks/useDevice';
import { useLanguageStore } from '@/store/modules/language';
import { UseGetCurrentGameConfigHooks } from '@/hooks/useGetCurrentGameConfigHooks';
import { useAuthStore } from '@/store/modules/auth';
export const UseReportData = function () {
  const {
    currentGameConfig
  } = UseGetCurrentGameConfigHooks();
  const {
    verifyRole
  } = storeToRefs(useAuthStore());
  const {
    isMobileReal
  } = useDevice();
  const {
    currentLanguage,
    currentCountry
  } = useLanguageStore();
  const $customEvent = function (type, params) {
    const data = _objectSpread({
      time: new Date().getTime(),
      login_status: verifyRole.value.cUid ? 1 : 0,
      game_id: currentGameConfig.value.usdkId,
      user_id: verifyRole.value.cUid,
      channel_id: verifyRole.value.cid,
      role_id: verifyRole.value.role_id,
      role_name: verifyRole.value.role_name,
      server_id: verifyRole.value.server_id,
      server_name: verifyRole.value.server_name,
      platform: isMobileReal.value ? 'mobile' : 'pc',
      web_source: sessionStorage.getItem('source') || '',
      game_name: currentGameConfig.value.name,
      lang: currentLanguage.key,
      lang_label: currentLanguage.label,
      area: currentCountry.key,
      area_label: currentCountry.label
    }, params);
    const nowType = `${process.env.VUE_APP_AREA}_${type}`;
    window.staticFn.customEvent(nowType, data);
  };
  return {
    $customEvent
  };
};